<template>
  <ProfileLayout>
    <router-view />
  </ProfileLayout>
</template>

<script>
import { authGuardRoute } from "@/guards";
import ProfileLayout from "@/layouts/ProfileLayout";
import userMixin from '@/mixins/user'

export default {
  name: "ProfileView",
  components: { ProfileLayout },
  beforeRouteEnter: authGuardRoute,
  mixins: [userMixin]
}
</script>
